import { useLocalStorage } from './useLocalStorage';
import { useOppositions } from './useOppositions';
/** Persisted per browser so Alumnos and Pagos share the same "accounting book". */
const STORAGE_KEY = 'apolo.director.opposition-filter';
/**
 * Shared director-wide opposition filter ("two accounting books"): the
 * selected opposition UUID ('' = all), persisted in localStorage and read by
 * both the students page and the payments page. Options derive from the
 * enabled oppositions, so future ones (Bomberos) appear without code changes.
 */
export function useOppositionFilter() {
    const { data: oppositions = [] } = useOppositions();
    const [stored, setOppositionId] = useLocalStorage(STORAGE_KEY, '');
    const enabled = oppositions.filter((o) => o.is_enabled);
    // While oppositions load, trust the stored id (avoids a flash of "Todas" +
    // a wasted refetch); once loaded, degrade stale/disabled ids to "Todas".
    const oppositionId = oppositions.length === 0 || enabled.some((o) => o.id === stored) ? stored : '';
    const options = [
        { value: '', label: 'Todas' },
        ...enabled.map((o) => ({ value: o.id, label: o.name })),
    ];
    return { oppositionId, setOppositionId, options };
}
//# sourceMappingURL=useOppositionFilter.js.map